import { amountFormate, formatDateTime } from "./AppHelper";

//Createdate Formatting Template
export const createdAtTemplate = (rowData: any, rowIndex: any) => {
  return (
    <>
      <div>
        {!window.cn(rowData[rowIndex.field])
          ? formatDateTime(rowData[rowIndex.field])
          : "-"}
      </div>
    </>
  );
};

// amount template
export const amountTemplate = (rowData: any, rowIndex: any) => {
  return (
    <>
      <div>
        {!window.cn(rowData[rowIndex.field])
          ? amountFormate(rowData[rowIndex.field])
          : "-"}
      </div>
    </>
  );
};

// global field template
export const globalFieldTemplate = (rowData: any, rowIndex: any) => {
  return (
    <span>
      {!window.cn(rowData[rowIndex.field]) ? rowData[rowIndex.field] : "-"}
    </span>
  );
};
